import React, { useEffect, useState } from 'react'
import { useAuthHandling } from '../useAuthhandling';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Config from '../Config';
import { ToastContainer, toast } from "react-toastify";
import Suspendmodal from '../Suspendmodal';
import ReactPaginate from 'react-paginate';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import Professionallist from './Professionallist';
import Normaluserlist from './Normaluserlist';
import { FaSearch } from 'react-icons/fa';
import Nodatafound from '../Nodatafound';

function Userlist() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    const [customerdata, setCustomer] = useState([]);

    const [paginate, setPaginate] = useState('');
    const [pagenum, setPagenum] = useState(1);
    const [pageindex, setPageindex] = useState(1);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState('');

    const [modal_animationFlip, setmodal_animationFlip] = useState(false);
    const [pageid, setPageid] = useState("");

    function tog_animationFlip(id) {
        setmodal_animationFlip(!modal_animationFlip);
        setPageid(id)
    }


    // const getinfo = async (e) => {

    //     const res = await fetch(
    //         `${Config.apiurl}/api/v1/crm/user/get-all-users?page=1`,
    //         {
    //             method: "GET",
    //             headers: {
    //                 Authorization: `Bearer ${Cookies.get("a_token")}`,
    //             },
    //         }
    //     );
    //     if (res.status === 200) {
    //         const data = await res.json();

    //         setCustomer(data.data[0].data);
    //         setPaginate(data.data[0].total_pages);
    //     }
    //     else if (res.status === 401) {
    //         handleUnauthorized();
    //     }
    //     else {
    //         toast.error("Something went wrong!", {
    //             position: "top-center",
    //             autoClose: 1500,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //         <ToastContainer />;
    //     }
    // };


    const DeleteData = async (id) => {
        setmodal_animationFlip(false);

        // const response = await fetch(
        //   `${Config.apiurl}/api/v1/crm/professional/delete-professional/${id}`,
        //   {
        //     method: "PUT",
        //     headers: {
        //       Authorization: `Bearer ${Cookies.get("a_token")}`,
        //     },
        //   }
        // );


        const response = await fetch(
            `${Config.apiurl}/api/v1/crm/professional/suspended-professional/${id}`,
            {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );
        const deletedata = await response.json();

        if (response.status === 200) {
            toast.success("Suspended Sucessfully!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handlePageClick(pagenum);


        }
        else if (response.status === 401) {
            handleUnauthorized();
            DeleteData(id);
        }
        else {
            toast.error("Something went wrong!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            <ToastContainer />;

        }
    };


    let handleChangetoggverify = async (id) => {

        const response = await fetch(
            `${Config.apiurl}/api/v1/crm/professional/professional-verify-update/${id}`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );


        if (response.status === 200) {
            const verifydata = await response.json();

            toast.success("Professional Verified Updated!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            handlePageClick(pagenum);


        }
        else if (response.status === 401) {
            handleUnauthorized();
            handleChangetoggverify();
        }
        else {
            toast.error("Something went wrong!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            <ToastContainer />;
        }

    }
    let handleChangetoggfeatured = async (id) => {

        const response = await fetch(
            `${Config.apiurl}/api/v1/crm/professional/professional-featured-update/${id}`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );


        if (response.status === 200) {
            const verifydata = await response.json();

            toast.success("Professional Featured Updated!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            handlePageClick(pagenum);

        }
        else if (response.status === 401) {
            handleUnauthorized();
            handleChangetoggfeatured();
        }
        else {
            toast.error("Something went wrong!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            <ToastContainer />;
        }

    }


    const fetchComments = async (currentPage) => {

        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/user/search-users?searchTerm=${search}&page=${currentPage}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );
        if (res.status === 200) {

            const data = await res.json();
            return data.data[0].data;
        }
        else if (res.status === 401) {
            handleUnauthorized();
            fetchComments(currentPage);
        }


    };

    const handlePageClick = async (data) => {
        if (data === 1) {
            setPageindex(1);

            setPagenum(data);
            const commentsFormServer = await fetchComments(data);
            setCustomer(commentsFormServer);
        }
        else {
            let currentPage = data.selected + 1;
            setPageindex(currentPage);

            setPagenum(data);
            const commentsFormServer = await fetchComments(currentPage);

            setCustomer(commentsFormServer);
        }

    };


    const getsearch = async (e) => {
        setCustomer([]);
        setPaginate([]);

        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/user/search-users?searchTerm=${search}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${Cookies.get("a_token")}`,
                },
            }
        );
        if (res.status === 200) {
            const data = await res.json();

            setCustomer(data.data[0].data);
            setPaginate(data.data[0].totalPages);
        }
        else if (res.status === 401) {
            handleUnauthorized();
            getsearch();
        }
        else {
            toast.error("Something went wrong!", {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            <ToastContainer />;
        }
    };


    // useEffect(() => {
    //     getinfo();
    // }, []);

    useEffect(() => {
        getsearch();
    }, [search]);

    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                {/* partial */}
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='user_list_search_all'>

                            <div className='user_all_list-head'>
                    
                                <Link className='user_all_list-head_a' to="/normaluserlist">Normaluser List</Link>

                                <Link className='user_all_list-head_a' to="/professionaluserlist">Professional List</Link>
                                <Link className='user_all_list-head_a' to="/suspendedlist">Suspended List</Link>
                                <Link className='user_all_list-head_a' to="/customerlist">Customer List</Link>

                            </div>
                            <div className='user_list_search'>
                                <input value={search} onChange={(e) => setSearch(e.target.value)} />
                                <FaSearch />
                            </div>

                        </div>



                        <div className="row">
                            <div className="col-lg-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">All user List</h4>

                                        <div className="table-responsive pt-3">
                                            {customerdata?.length>0?
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Sl No</th>
                                                        <th>Name</th>
                                                        <th>Contact Number</th>
                                                        <th>User type</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                               
                                                <tbody>
                                                {customerdata.length>0?
                                                    customerdata.map((element, i) => {
                                                        return (
                                                            <>
                                                                <tr key={i}>
                                                                    <th scope="row">{pageindex === 1 ? i + 1 : (pageindex - 1) * 10 + i + 1}</th>
                                                                    <td>{element.name}</td>
                                                                    <td>{element.mobile}</td>
                                                                    <td className='loc_wrap'>
                                                                        <ul>
                                                                            {element?.userType?.map((type, i) => {
                                                                                return (
                                                                                    <>
                                                                                        {type === 'normal-user' ?
                                                                                            <li>Customer</li>
                                                                                            :
                                                                                            <li>Professional User</li>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </ul>
                                                                    </td>

                                                                    <td className='actions_td'>
                                                                        {/* <Link
                                     
                                      className='action_icons'
                                      onClick={() => tog_animationFlip(element._id)}
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </Link>
                                  
                                      <Link
                                        to={`/editcustomer/${element._id}`}
                                        className="fa-solid fa-pen action_icons"
                                   
                                      ></Link> */}

                                                                        {element?.userType.length === 2 ?
                                                                            <Link to={"/userview/" + element._id}

                                                                                state={{
                                                                                    type: "2type"

                                                                                }}

                                                                                className="action_icons" >
                                                                                <i className="fa-solid fa-eye" />
                                                                            </Link>
                                                                            :
                                                                            element.userType[0] === 'normal-user' ?
                                                                                <Link to={"/userview/" + element._id}

                                                                                    state={{
                                                                                        type: "normal-user"
                                                                                    }}

                                                                                    className="action_icons" >
                                                                                    <i className="fa-solid fa-eye" />
                                                                                </Link>
                                                                                :

                                                                                <Link to={"/userview/" + element._id}

                                                                                    state={{
                                                                                        type: "professional-user"

                                                                                    }}

                                                                                    className="action_icons" >
                                                                                    <i className="fa-solid fa-eye" />
                                                                                </Link>}


                                                                        <ToastContainer />
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })
                                                    :
                                                    <tr>
                                                    <td
                                                      style={{ textAlign: "center" }}
                                                      colSpan="5"
                                                    >
                                                      No data found
                                                    </td>
                                                  </tr>
                                                    }
                                                </tbody>
                                                
                                               
                                                
                                            </table>
                                            :
                                            <Nodatafound/>
                                                }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {paginate > 1 ? (
                            <ReactPaginate
                                previousLabel={"previous"}
                                nextLabel={"next"}
                                breakLabel={"..."}
                                pageCount={paginate}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination justify-content-center"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>

                {modal_animationFlip ? (
                    <Suspendmodal
                        modal_animationFlip={modal_animationFlip}
                        tog_animationFlip={tog_animationFlip}
                        pageid={pageid}
                        DeleteData={DeleteData}
                        message={"Professional"}
                    />
                ) : (
                    ""
                )}
            </div>
        </div>
    )
}

export default Userlist
